const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'FIELD_VALUE':
      return _addField(state, action.field, action.value);
    case 'DELETE_FIELD':
      return _deleteField(state, action.field);
    case 'CLEAR_FIELDS':
      return {...initialState};
    default:
      return state;
  }
}

const _addField = (state, field, value) => {
  let obj = {...state};
  obj[field] = value;
  return obj;
};

const _deleteField = (state, field) => {
  let obj = {...state};
  delete obj[field];
  return obj;
};


// WEBPACK FOOTER //
// ./src/reducers/field-reducer.js